export default "__VITE_ASSET__733ace18__"